import type { DashboardReport } from './dashboard-report.type.ts';

export type { SizeConfig } from './dashboard-report.type.ts';
export interface DashboardReportExtension extends DashboardReport {}
export class DashboardReportExtension {
  get size() {
    return this.sizeConfig?.size ?? 'medium';
  }
}

const Registration = {
  kind: 'object',
  name: 'dashboard-report',
  features: DashboardReportExtension,
};
export default Registration;
